/**
 * Created by Denis Kuzin on 27 july 2022
 */

cc.CollectEffect = function (target, overScale) {
    const scaleX = target.baseScaleX || target.baseScale || 1;
    const scaleY = target.baseScaleY || target.baseScale || 1;

    cc.CallFunc.prototype.constructor.call(this, () => {
        if (!target.isRunning()) {
            return;
        }

        overScale = overScale || 1.1;
        target.runAction(new cc.Sequence(
            new cc.ScaleTo(0.15, scaleX * overScale, scaleY * overScale).easing(cc.easeOut(2)),
            new cc.ScaleTo(0.15, scaleX, scaleY).easing(cc.easeInOut(2))
        ));
    });
};
cc.CollectEffect.prototype = Object.assign(Object.create(cc.CallFunc.prototype), {
    constructor: cc.CollectEffect
});

cleverapps.styles.CollectEffect = {
    sparks: {
        x: -7,
        y: 5
    }
};